var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_c('div', {
    staticClass: "plan-tabs"
  }, [_c('button', {
    staticClass: "plan-tab saidas",
    class: {
      active: _vm.activeTab === 'saidas'
    },
    on: {
      "click": function click($event) {
        return _vm.setTab('saidas');
      }
    }
  }, [_vm._v("Saídas")]), _c('button', {
    staticClass: "plan-tab entradas",
    class: {
      active: _vm.activeTab === 'entradas'
    },
    on: {
      "click": function click($event) {
        return _vm.setTab('entradas');
      }
    }
  }, [_vm._v("Entradas")])]), _c('b-button', {
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        return _vm.showAddModal(null);
      }
    }
  }, [_vm._v("+ Adicionar")])], 1), _c('div', {
    staticClass: "plan-table"
  }, [_vm._m(0), _vm._l(_vm.filteredNodes, function (node, index) {
    return _c('TreeNode', {
      key: node.id || index,
      attrs: {
        "node": node,
        "dreGrupos": _vm.dreGrupos
      },
      on: {
        "add-child": _vm.addChild,
        "delete-node": _vm.deleteNode
      }
    });
  }), _vm.filteredNodes.length === 0 ? _c('div', {
    staticClass: "plan-empty"
  }, [_vm._v(" Nenhum plano de contas cadastrado nesta categoria. ")]) : _vm._e()], 2), _c('b-modal', {
    attrs: {
      "title": "Adicionar Plano de Contas",
      "centered": "",
      "size": "lg"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          ref: "saveNewNode",
          staticClass: "mr-2",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.saveNewNode
          }
        }, [_vm._v("Salvar")]), _c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("Cancelar")])], 1)];
      }
    }]),
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "50",
      "required": ""
    },
    model: {
      value: _vm.newNodeName,
      callback: function callback($$v) {
        _vm.newNodeName = $$v;
      },
      expression: "newNodeName"
    }
  })], 1)], 1), _vm.parentNode !== null ? _c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Grupo DRE:",
      "label-for": "dre-grupo-select"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "dre-grupo-select",
      "options": _vm.dreGruposOptions
    },
    model: {
      value: _vm.newDreGrupo,
      callback: function callback($$v) {
        _vm.newDreGrupo = $$v;
      },
      expression: "newDreGrupo"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "plan-table-header"
  }, [_c('span', [_vm._v("Categoria")]), _c('span', [_vm._v("Ações")])]);
}];
export { render, staticRenderFns };